import React from 'react'
import SEO from "../../common/SEO";
import HeaderOne from '../../common/header/HeaderOne';
import HeaderTopBar from '../../common/header/HeaderTopBar';
import FooterOne from '../../common/footer/FooterOne';
import Copyright from '../../common/footer/Copyright';
import TermsAndCondition from '../../components/others/TermsAndCondition';



const TermsandCondition = () => {
    return (
        <>
            <SEO title="Terms And Condition" />
            <main className="page-wrapper">
                <HeaderTopBar />
                <HeaderOne btnStyle="btn-small" HeaderSTyle="header-transparent" />

                {/* This is the Service Categories Area */}
                <div className="rwt-advance-tab-area rn-section-gap d-flex justify-content-center">
                    <div className="w-100">
                        <div className="container">
                            <TermsAndCondition />
                        </div>
                    </div>
                </div>








                <FooterOne />
                <Copyright />
            </main>

        </>
    )
}

export default TermsandCondition
